//import { AppEnv } from "./properties";
//import { TYPE_APP, TYPE_DOMAIN } from "./services/constants";

export function getHost() {
  if (window.location.hostname.toLowerCase().indexOf('salesleadsdev') >= 0
  ) {
    return `https://apidev.parker.com/dev/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadstest') >= 0
  ) {
    return `https://apidev.parker.com/test/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadsstage') >= 0
  ) {
    return `https://api.parker.com/stage/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleads.parker') >= 0
  ) {
    return `https://api.parker.com/prod/`;
  } else return `https://apidev.parker.com/test/`;
}

export function getAPIAuthKey() {
 return ``;
}

/* export function getHeaderAuthKey() {
  if (
    window.location.hostname.toLowerCase().indexOf("salesleadsdev") >= 0
  
  ) {
    return ``;
}
} */

export function getAPIAuthKeyHeaderFooter() {
  if (window.location.hostname.toLowerCase().indexOf('salesleadsdev') >= 0) {
    return ``;
  } 
}

export function getPHHost() {
  if (window.location.hostname.toLowerCase().indexOf('salesleadsdev') >= 0) {
    return `https://phdev.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadstest') >= 0
  ) {
    return `https://phtest.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadsstage') >= 0
  ) {
    return `https://phstage.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleads.parker') >= 0
  ) {
    return `https://ph.parker.com/`;
  } else return `https://phtest.parker.com/`;
}

export function getParkerHost() {
  if (window.location.hostname.toLowerCase().indexOf('salesleadsdev') >= 0) {
    return `https://dev.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadstest') >= 0
  ) {
    return `https://test.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadsstage') >= 0
  ) {
    return `https://preview.parker.com/`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleads.parker') >= 0
  ) {
    return `https://www.parker.com/`;
  } else return `https://test.parker.com/`;
}
 
export function getEnviorment() {
  if (window.location.hostname.toLowerCase().indexOf('salesleadsdev') >= 0) {
    return `dev`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadstest') >= 0
  ) {
    return `test`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleadsstage') >= 0
  ) {
    return `stage`;
  } else if (
    window.location.hostname.toLowerCase().indexOf('salesleads.parker') >= 0
  ) {
    return `prod`;
  } else return `test`;
}
